module.exports = __webpack_public_path__ + "static/media/sts_logo.2b336ed8.png";